import { UseQueryResult, useQuery, useQueryClient } from '@tanstack/react-query'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  DEFAULT_CACHE_TIME_MS,
  QUERY_PARKING_EVENT_DETAILS,
} from '../../../apis/moovyQueryKeys'
import {
  MoovyContainer,
  MoovyContainerContent,
  MoovyContainerHeader,
  MoovyTab,
} from '../../../components'

import { AxiosResponse } from 'axios'
import { useParams } from 'react-router-dom'
import { ParkingEventDetailsDTO } from '../../../apis/parkingEvents/dto'
import { ParkingEventsApi } from '../../../apis/parkingEvents/parkingEventsApi'
import MoovyQueryHandler from '../../../components/moovyQueryHandler'
import ParkingDetailsCameraTab from './cameraTab'
import ParkingDetailsSummary from './summary'

const ParkingDetails = () => {
  const { parkingEventRef } = useParams()

  const intl = useIntl()
  const formattedMessage = (id: string) => intl.formatMessage({ id })

  const queryClient = useQueryClient()
  const queryParkingDetails: UseQueryResult<
    AxiosResponse<ParkingEventDetailsDTO, any>
  > = useQuery({
    queryKey: [QUERY_PARKING_EVENT_DETAILS, parkingEventRef],
    queryFn: () => {
      return ParkingEventsApi.getParkingEventDetails(parkingEventRef!)
    },
    staleTime: DEFAULT_CACHE_TIME_MS,
  })

  return (
    <MoovyQueryHandler query={queryParkingDetails} rootPageIfNotFoundError>
      <MoovyContainer loading={queryParkingDetails.isLoading}>
        <MoovyContainerHeader>
          <FormattedMessage id="page.parkingDetails.title" />
        </MoovyContainerHeader>
        <MoovyContainerContent>
          <MoovyTab
            tabKey="parkingDetailsTab"
            tabHeaders={[
              formattedMessage('page.parkingDetails.summary'),
              formattedMessage('page.parkingDetails.entryCamera'),
              formattedMessage('page.parkingDetails.exitCamera'),
            ]}
            tabPanels={[
              <ParkingDetailsSummary
                parkingDetails={queryParkingDetails.data?.data}
                parkingDetailsRef={parkingEventRef!}
                queryClient={queryClient}
              />,
              <ParkingDetailsCameraTab
                cameraRole="ENTRY"
                parkingDetails={queryParkingDetails.data?.data}
              />,
              <ParkingDetailsCameraTab
                cameraRole="EXIT"
                parkingDetails={queryParkingDetails.data?.data}
              />,
            ]}
          />
          {queryParkingDetails.error && (
            <h3>Error: {queryParkingDetails.error.message}</h3>
          )}
        </MoovyContainerContent>
      </MoovyContainer>
    </MoovyQueryHandler>
  )
}

export default ParkingDetails
